/** Short standalone greetings — route to general chat, not workflow slot validation. */
export const GREETING_RE =
  /^(hi|hello|hey|thanks|thank you|ok|okay|bye|goodbye|good morning|good afternoon)[\s!.]*$/i;

/** Help / capability questions — route to general chat during an active workflow. */
export const HELP_RE =
  /^(help|what can you do|how does this work|how do i use this|what do you do)[\s?!.]*$/i;

export function isConversationalInterrupt(text: string): boolean {
  const trimmed = text.trim();
  return GREETING_RE.test(trimmed) || HELP_RE.test(trimmed);
}
